import Component from '../core/Component';

export default class ToggleNav extends Component {
    prepare() {
        this.burgerIcon = document.querySelector(".burger");
        this.menu = document.querySelector(".topbar__menu");
        this.menuWrapper = document.querySelector(".topbar__mobileMenu");

        this.burgerIcon.addEventListener("click", ::this.handleClick);
    }

    handleClick() {
        this.burgerIcon.classList.toggle("is-open");
        this.menu.classList.toggle("is-open");
        this.menuWrapper.classList.toggle("is-open");
        document.querySelector("html").classList.toggle('is-open');
        document.querySelector(".topbar").classList.toggle("is-open")
    }
}



// WEBPACK FOOTER //
// ./components/ToggleNav.js